import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function formatDate(date) {
  try {
    return dayjs.utc(date).local().format("MMMM D, YYYY h:mm A");
  } catch (e) {
    return date;
  }
}
